/* eslint-disable no-nested-ternary */
import React from 'react'
import UserCard from '@/components/conversation-insights/user-card';
import DeltaArrowIcon from '@/components/conversation-insights/delta-arrow';
import { hasValidKey } from '@/lib/utils';
import { Member, Option } from '@/utils/types';

const MemberItem = ({
    workspaceUsersObj,
    member,
  }: {
    workspaceUsersObj: { [key: string]: Option };
    member: Member;
  }) => (
    <div
      className="w-full p-3 border border-[#E4E4E7] flex items-center justify-between rounded-[12px] cursor-pointer"
    >
      {workspaceUsersObj?.[member?.user_id] && (
        <UserCard user={workspaceUsersObj?.[member?.user_id]} showEmail truncate/>
      )}
      {(hasValidKey(member, 'value') || hasValidKey(member, 'percentage')) && (
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-1">
            <p className="text-base font-medium">
              {hasValidKey(member, "percentage") ? `${member?.percentage}%` : member?.value}
            </p>
            {hasValidKey(member, "changes") && (
              <span
                className={`text-xs flex items-center gap-1 ${
                  (member?.changes || 0) < 0 ? "text-[#F0412F]" : (member?.changes || 0) > 0 ? 'text-[#34A853]' : 'text-[#8A919F]'
                }`}
              >
                {member?.changes}%
                {member?.changes !== 0 && (
                  <DeltaArrowIcon className={`w-4 h-3 ${(member?.changes || 0) < 0 ? 'fill-[#F0412F] scale-x-[-1] rotate-180' : 'fill-[#34A853]'}`}/>
                )}
              </span>
            )}
          </div>
          <span className="text-xs font-normal text-[505056]">
            {member?.label}
          </span>
        </div>
      )}
    </div>
  );

export default MemberItem